var Utils = require("./utils");
var queryArray = Utils.queryArray;

var leadershipCategories = queryArray(".category");

leadershipCategories.forEach(function(item) {
  item.addEventListener("click", function() {
    var leadershipCat = item.getAttribute("data-section");
    var leadershipSection = document.querySelector(".section--leadership#" + leadershipCat + "");
    queryArray(".section--leadership").forEach(function(i){
      i.classList.remove("active");
    });
    queryArray(".category").forEach(function(i){
      i.classList.remove("active");
    });
    item.classList.add("active");
    leadershipSection.classList.add("active");
  });
});

function checkCategories() {
  if (window.location.hash == "#executive-committee") {
    document.querySelector(".section--leadership#executive-committee").classList.add("active");
    document.querySelector(".category[data-section='executive-committee']").classList.add("active");
  } else if (window.location.hash == "#officers") {
    document.querySelector(".section--leadership#officers").classList.add("active");
    document.querySelector(".category[data-section='officers']").classList.add("active");
  } else if (window.location.hash == "#chairmans-advisory-council") {
    document.querySelector(".section--leadership#chairmans-advisory-council").classList.add("active");
    document.querySelector(".category[data-section='chairmans-advisory-council']").classList.add("active");
  } else if (window.location.hash == "#board-of-directors"){
    document.querySelector(".section--leadership#board-of-directors").classList.add("active");
    document.querySelector(".category[data-section='board-of-directors']").classList.add("active");
  }
}

window.addEventListener("hashchange", checkCategories);
window.addEventListener("DOMContentLoaded", checkCategories);